$(document).ready(function() {
    $(".element-title-with-media .media-image").click(function() {
        var href = $(this).attr('data-link');
        var openInNewWindow = $(this).attr('data-new-window');

        if (href) {
            if (openInNewWindow) {
                window.open(href);
            } else {
                window.location = href;
            }
        }

        return false;
    });
});